import { render, staticRenderFns } from "./IGDAssessment.vue?vue&type=template&id=46a5c702&scoped=true"
import script from "./IGDAssessment.vue?vue&type=script&lang=js"
export * from "./IGDAssessment.vue?vue&type=script&lang=js"
import style0 from "./IGDAssessment.vue?vue&type=style&index=0&id=46a5c702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5c702",
  null
  
)

export default component.exports